import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router";

const NonUserRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return localStorage.getItem("credentials") ? (
        <Redirect to="/" />
      ) : (
        <Component {...props} />
      );
    }}
  />
);

NonUserRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

export default NonUserRoute;



// WEBPACK FOOTER //
// ./src/helpers/NonUserRoute.js